export default function removeInputElement(element) {
  const parent = element.parentElement;
  const inputValue = element.firstElementChild.value;
  parent.removeChild(element);
  parent.parentElement.classList.remove('format-done');

  return {
    parent,
    inputValue,
  };
}



// WEBPACK FOOTER //
// ./js/components/tables/inline-edit/removeElements/removeInputElement.js